import { Map, NavigationControl, Marker, Popup } from "maplibre-gl";

[...document.querySelectorAll(".-map")].forEach((container) => {
    const addressHTML = container.innerHTML;
    container.innerHTML = "";
    const dataSet = container.dataset;
    const center = [dataSet.lon, dataSet.lat];

    const map = new Map({
        container,
        center,
        zoom: dataSet.zoom || 12,
        scrollZoom: false,
        maxZoom: 20,
        style: "https://tiles.stadiamaps.com/styles/alidade_smooth.json",
    });

    map.addControl(new NavigationControl());

    const marker = new Marker({ color: "#d91a39", draggable: false });
    marker.setLngLat(center);
    marker.addTo(map);

    if (addressHTML) {
        const popup = new Popup({ closeButton: false, maxWidth: "500px" });
        popup.setHTML(addressHTML);
        marker.setPopup(popup);
        marker.togglePopup();
    }

    container.classList.remove("invisible");
});
